import { makeAutoObservable } from 'mobx';
import createStoreContext from '../createStoreContext';
import { AlertColor, AlertProps } from '@mui/material';
import { NotificationPayload } from 'src/types/notification';

const NOTIFICATION_TIMEOUT = 5000; // in milliseconds

export const [AlertStoreProvider, useAlertStore] = createStoreContext(
  class AlertStore {
    showNotification = false;
    notificationPayload: NotificationPayload | null = null;
    callbackOfManualToastClose: (() => void) | null = null;
    callbackOfAutoToastClose: (() => void) | null = null;
    action: AlertProps['action'] | null = null;
    private notificationTimeoutId: NodeJS.Timeout | null = null;

    public constructor() {
      makeAutoObservable(this);
    }

    notify = (
      message: string,
      severity: AlertColor,
      autoClose = true,
      callbackOfManualToastClose: (() => void) | null = null,
      action: AlertProps['action'] | null = null,
      callbackOfAutoToastClose: (() => void) | null = null,
    ) => {
      if (this.notificationTimeoutId !== null) {
        clearTimeout(this.notificationTimeoutId);
      }

      this.showNotification = true;
      this.notificationPayload = {
        message,
        severity,
      };

      if (callbackOfManualToastClose) {
        this.callbackOfManualToastClose = callbackOfManualToastClose;
      }

      if (callbackOfAutoToastClose) {
        this.callbackOfAutoToastClose = callbackOfAutoToastClose;
      }

      if (autoClose) {
        this.notificationTimeoutId = setTimeout(() => {
          if (this.callbackOfAutoToastClose) {
            this.callbackOfAutoToastClose();
          }

          this.reset();
        }, NOTIFICATION_TIMEOUT);
      }

      if (action) {
        this.action = action;
      }
    };

    reset = () => {
      this.showNotification = false;
      this.notificationPayload = null;
      this.callbackOfManualToastClose = null;
      this.callbackOfAutoToastClose = null;
      this.action = null;
    };
  },
);

export type AlertStore = ReturnType<typeof useAlertStore>;
